import React, { useState, useEffect } from 'react';
import { useDebounceFn } from 'ahooks';

interface IUseIsTextOverflowProps {
  text: string;
  maxLines?: number; // 支持指定最大行数，默认为 1
}

export default function useIsTextOverflow(
  wrapper: React.RefObject<HTMLElement | null>,
  props: IUseIsTextOverflowProps
) {
  const { text, maxLines = 1 } = props;

  const [isOverflow, setIsOverflow] = useState(false);

  const updateIsOverflow = () => {
    if (!wrapper.current) return;

    if (maxLines === 1) {
      // 单行检测：比较宽度
      const { scrollWidth, clientWidth } = wrapper.current;
      setIsOverflow(scrollWidth > clientWidth);
    } else {
      // 多行检测：比较高度
      const { scrollHeight, clientHeight } = wrapper.current;
      setIsOverflow(scrollHeight > clientHeight);
    }
  };

  const { run: handleResize } = useDebounceFn(
    () => {
      updateIsOverflow();
    },
    { wait: 600 }
  );

  useEffect(() => {
    updateIsOverflow();
  }, [text, maxLines]);

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, []);

  return isOverflow;
}

